var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBybit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h18v18H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10V6h.723v4H12Z",
    fill: "#F7A600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11h1.55c.661 0 1.134-.377 1.134-1.048a.836.836 0 0 0-.51-.809.83.83 0 0 0 .459-.743c0-.616-.422-1.01-1.145-1.01H2V11Zm.723-3h.708c.307 0 .478.183.478.43 0 .248-.171.415-.478.415h-.708V8Zm0 1.477h.755c.327 0 .483.197.483.44 0 .242-.156.444-.483.444h-.755v-.884ZM6.89 11V9.512L8.003 7.39h-.785l-.682 1.45-.692-1.45H5.06l1.113 2.122V11h.718Zm3.163 0h-1.55V7.39H9.99c.723 0 1.145.394 1.145 1.01 0 .4-.271.657-.458.743.223.101.51.328.51.809 0 .671-.474 1.048-1.135 1.048Zm-.12-3h-.707v.845h.708c.307 0 .478-.167.478-.415 0-.247-.171-.43-.478-.43Zm.047 1.477h-.754v.884h.754c.328 0 .484-.202.484-.445 0-.242-.156-.44-.484-.44ZM15 11V8h1v-.61H13.34V8h.968v3H15Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 3.349,
    y1: 3.122,
    x2: 21.904,
    y2: 24.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06060A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBybit);
export default __webpack_public_path__ + "static/media/bybit.71d8632ace06cf394cd68852fb6cab91.svg";
export { ForwardRef as ReactComponent };